import { Box } from "@mui/material";
import { PendingAction } from "./actionsRequired";
import { Chip, Typography } from "@mui/joy";

/**
 *
 * @param root0
 * @param root0.action
 * @param root0.onOpen
 * @returns {ReactElement} ActionCard page
 */
export function ActionCard({
  action,
  onOpen,
}: {
  action: PendingAction;
  onOpen?: (url: string, title?: string) => void;
}) {
  let name = "";
  let icon = "fa-regular fa-folder";
  if (action.project != null) {
    name = action.project.name;
  }

  if (action.season != null) {
    name = action.season.name;
    icon = "fa-regular fa-ticket";
  }

  const gigCount = action.gigs.filter((g) => g.isPlaying()).length;

  return (
    <Box
      onClick={() => {
        const url = action.gigs[0].getInviteURL();
        if (!url) return;
        if (onOpen) {
          onOpen(url, name || action.contractor?.name);
        } else {
          window.open(url);
        }
      }}
      sx={{
        width: 192,
        height: 120,
        flexShrink: 0,
        background: action.stage?.color,
        borderRadius: "16px",
        p: 1.5,
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        boxShadow:
          "0 1px 2px rgba(0, 0, 0, 0.06), 0 6px 16px rgba(0, 0, 0, 0.08)",
        transition: "all 0.25s cubic-bezier(0.3, 0, 0.2, 1)",
        "&:hover": {
          transform: "translateY(-2px) scale(1.01)",
          boxShadow:
            "0 2px 4px rgba(0, 0, 0, 0.06), 0 14px 28px rgba(0, 0, 0, 0.14)",
        },
        "&:active": {
          transform: "scale(0.99)",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          sx={{ color: "white" }}
          startDecorator={
            action.gigs[0]?.isCattleCall() ? (
              <i
                className="fa-solid fa-cowbell fa-shake"
                style={{ fontSize: 16, color: "white" }}
              />
            ) : (
              <img
                src={action?.stage?.icon}
                style={{
                  height: 16,
                  filter: "brightness(0) saturate(100%) invert(100%)",
                }}
              />
            )
          }
        >
          <b>{action.stage?.name}</b>
        </Typography>
        <Typography sx={{ color: "white" }}>
          <i className={icon} />
        </Typography>
      </Box>
      <Typography sx={{ color: "white" }} level="body2">
        <b>{name}</b>
      </Typography>
      <Typography sx={{ color: "white" }} level="body3">
        {`${gigCount} Service${gigCount != 1 ? "s" : ""}`}
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      <Chip
        size="sm"
        sx={{ background: "rgba(255,255,255,0.2)", color: "white" }}
        color="neutral"
        variant="soft"
      >
        {action.contractor?.name}
      </Chip>
    </Box>
  );
}
